import { Borrower } from './borrower.model';
import { BorrowerService } from './borrower.service';
import { Injectable } from '@angular/core';
import { ModelStore } from '../../../shared/stores/model.store';

@Injectable()
export class BorrowerStore extends ModelStore<Borrower> {

    constructor(borrowerService: BorrowerService) {
        super(borrowerService);
    }
}
